var K = Object.defineProperty;
var ee = (n, e, t) =>
  e in n
    ? K(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
    : (n[e] = t);
var g = (n, e, t) => (ee(n, typeof e != 'symbol' ? e + '' : e, t), t);
var te = /* @__PURE__ */ ((n) => (
    (n[(n.INLINE = 1)] = 'INLINE'),
    (n[(n.GLOBAL = 2)] = 'GLOBAL'),
    (n[(n.SYSTEM = 4)] = 'SYSTEM'),
    n
  ))(te || {}),
  I = /* @__PURE__ */ ((n) => (
    (n.USER = 'USER'),
    (n.TIMEOUT = 'TIMEOUT'),
    (n.CREATOR = 'CREATOR'),
    (n.CONSUMER = 'CONSUMER'),
    n
  ))(I || {}),
  y = /* @__PURE__ */ ((n) => (
    (n.NO_CONSUMERS = 'NO_CONSUMERS'),
    (n.WRONG_SCOPES = 'WRONG_SCOPES'),
    (n.WRONG_TYPES = 'WRONG_TYPES'),
    (n.WRONG_WINDOW = 'WRONG_WINDOW'),
    (n.REQUIRES_EXPLICIT_TYPE = 'REQUIRES_EXPLICIT_TYPE'),
    (n.REQUIRES_ACTIVE = 'REQUIRES_ACTIVE'),
    (n.META_FILTER_MISSING_FIELD = 'META_FILTER_MISSING_FIELD'),
    (n.META_FILTER_VALUE_MISMATCH = 'META_FILTER_VALUE_MISMATCH'),
    (n.NOT_ALIVE = 'NOT_ALIVE'),
    n
  ))(y || {});
let ne = 1;
function H() {
  return String(ne++);
}
function oe() {
  return null;
}
let se = () => '';
const re = () => se(),
  ie = (n, e, ...t) => {
    typeof t[0] == 'string'
      ? e.call(console, `${n.namespace}: ${t[0]}`, ...t.slice(1))
      : e.call(console, `${n.namespace}:`, ...t);
  };
function ae(n, e) {
  return e.bind(console);
}
function U(n, e, t) {
  return (...o) => {
    ie(n, e, ...o);
  };
}
function E(n, e, t) {
  return (...o) => {
    n.debugLoggers[t](...o);
  };
}
function ce(n, e) {
  return (...t) => {
    t.length > 1
      ? e.call(console, t[0], `${n.namespace}: ${t[1]}`, ...t.slice(2))
      : t.length === 1 && e.call(console, t[0], n.namespace);
  };
}
const ue = {
    log: E,
    warn: E,
    error: E,
    info: E,
    debug: E,
    time: U,
    timeEnd: U,
    timeLog: U,
    assert: ce,
  },
  le = (n, e, t) => {
    const o = (ue[e] ?? ae)(n, console[e], e);
    return (...s) => {
      for (const i of t) i(n, e, ...s);
      o(...s);
    };
  };
function de(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, 'default')
    ? n.default
    : n;
}
var B = { exports: {} },
  L,
  j;
function fe() {
  if (j) return L;
  j = 1;
  var n = 1e3,
    e = n * 60,
    t = e * 60,
    o = t * 24,
    s = o * 7,
    i = o * 365.25;
  L = function (r, a) {
    a = a || {};
    var d = typeof r;
    if (d === 'string' && r.length > 0) return l(r);
    if (d === 'number' && isFinite(r)) return a.long ? c(r) : u(r);
    throw new Error(
      'val is not a non-empty string or a valid number. val=' +
        JSON.stringify(r),
    );
  };
  function l(r) {
    if (((r = String(r)), !(r.length > 100))) {
      var a =
        /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
          r,
        );
      if (a) {
        var d = parseFloat(a[1]),
          w = (a[2] || 'ms').toLowerCase();
        switch (w) {
          case 'years':
          case 'year':
          case 'yrs':
          case 'yr':
          case 'y':
            return d * i;
          case 'weeks':
          case 'week':
          case 'w':
            return d * s;
          case 'days':
          case 'day':
          case 'd':
            return d * o;
          case 'hours':
          case 'hour':
          case 'hrs':
          case 'hr':
          case 'h':
            return d * t;
          case 'minutes':
          case 'minute':
          case 'mins':
          case 'min':
          case 'm':
            return d * e;
          case 'seconds':
          case 'second':
          case 'secs':
          case 'sec':
          case 's':
            return d * n;
          case 'milliseconds':
          case 'millisecond':
          case 'msecs':
          case 'msec':
          case 'ms':
            return d;
          default:
            return;
        }
      }
    }
  }
  function u(r) {
    var a = Math.abs(r);
    return a >= o
      ? Math.round(r / o) + 'd'
      : a >= t
      ? Math.round(r / t) + 'h'
      : a >= e
      ? Math.round(r / e) + 'm'
      : a >= n
      ? Math.round(r / n) + 's'
      : r + 'ms';
  }
  function c(r) {
    var a = Math.abs(r);
    return a >= o
      ? h(r, a, o, 'day')
      : a >= t
      ? h(r, a, t, 'hour')
      : a >= e
      ? h(r, a, e, 'minute')
      : a >= n
      ? h(r, a, n, 'second')
      : r + ' ms';
  }
  function h(r, a, d, w) {
    var N = a >= d * 1.5;
    return Math.round(r / d) + ' ' + w + (N ? 's' : '');
  }
  return L;
}
function he(n) {
  (t.debug = t),
    (t.default = t),
    (t.coerce = c),
    (t.disable = i),
    (t.enable = s),
    (t.enabled = l),
    (t.humanize = fe()),
    (t.destroy = h),
    Object.keys(n).forEach((r) => {
      t[r] = n[r];
    }),
    (t.names = []),
    (t.skips = []),
    (t.formatters = {});
  function e(r) {
    let a = 0;
    for (let d = 0; d < r.length; d++)
      (a = (a << 5) - a + r.charCodeAt(d)), (a |= 0);
    return t.colors[Math.abs(a) % t.colors.length];
  }
  t.selectColor = e;
  function t(r) {
    let a,
      d = null,
      w,
      N;
    function C(...p) {
      if (!C.enabled) return;
      const b = C,
        T = Number(/* @__PURE__ */ new Date()),
        Q = T - (a || T);
      (b.diff = Q),
        (b.prev = a),
        (b.curr = T),
        (a = T),
        (p[0] = t.coerce(p[0])),
        typeof p[0] != 'string' && p.unshift('%O');
      let _ = 0;
      (p[0] = p[0].replace(/%([a-zA-Z%])/g, (A, X) => {
        if (A === '%%') return '%';
        _++;
        const D = t.formatters[X];
        if (typeof D == 'function') {
          const Z = p[_];
          (A = D.call(b, Z)), p.splice(_, 1), _--;
        }
        return A;
      })),
        t.formatArgs.call(b, p),
        (b.log || t.log).apply(b, p);
    }
    return (
      (C.namespace = r),
      (C.useColors = t.useColors()),
      (C.color = t.selectColor(r)),
      (C.extend = o),
      (C.destroy = t.destroy),
      Object.defineProperty(C, 'enabled', {
        enumerable: !0,
        configurable: !1,
        get: () =>
          d !== null
            ? d
            : (w !== t.namespaces && ((w = t.namespaces), (N = t.enabled(r))),
              N),
        set: (p) => {
          d = p;
        },
      }),
      typeof t.init == 'function' && t.init(C),
      C
    );
  }
  function o(r, a) {
    const d = t(this.namespace + (typeof a > 'u' ? ':' : a) + r);
    return (d.log = this.log), d;
  }
  function s(r) {
    t.save(r), (t.namespaces = r), (t.names = []), (t.skips = []);
    let a;
    const d = (typeof r == 'string' ? r : '').split(/[\s,]+/),
      w = d.length;
    for (a = 0; a < w; a++)
      d[a] &&
        ((r = d[a].replace(/\*/g, '.*?')),
        r[0] === '-'
          ? t.skips.push(new RegExp('^' + r.substr(1) + '$'))
          : t.names.push(new RegExp('^' + r + '$')));
  }
  function i() {
    const r = [...t.names.map(u), ...t.skips.map(u).map((a) => '-' + a)].join(
      ',',
    );
    return t.enable(''), r;
  }
  function l(r) {
    if (r[r.length - 1] === '*') return !0;
    let a, d;
    for (a = 0, d = t.skips.length; a < d; a++)
      if (t.skips[a].test(r)) return !1;
    for (a = 0, d = t.names.length; a < d; a++)
      if (t.names[a].test(r)) return !0;
    return !1;
  }
  function u(r) {
    return r
      .toString()
      .substring(2, r.toString().length - 2)
      .replace(/\.\*\?$/, '*');
  }
  function c(r) {
    return r instanceof Error ? r.stack || r.message : r;
  }
  function h() {
    console.warn(
      'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.',
    );
  }
  return t.enable(t.load()), t;
}
var ge = he;
(function (n, e) {
  (e.formatArgs = o),
    (e.save = s),
    (e.load = i),
    (e.useColors = t),
    (e.storage = l()),
    (e.destroy = /* @__PURE__ */ (() => {
      let c = !1;
      return () => {
        c ||
          ((c = !0),
          console.warn(
            'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.',
          ));
      };
    })()),
    (e.colors = [
      '#0000CC',
      '#0000FF',
      '#0033CC',
      '#0033FF',
      '#0066CC',
      '#0066FF',
      '#0099CC',
      '#0099FF',
      '#00CC00',
      '#00CC33',
      '#00CC66',
      '#00CC99',
      '#00CCCC',
      '#00CCFF',
      '#3300CC',
      '#3300FF',
      '#3333CC',
      '#3333FF',
      '#3366CC',
      '#3366FF',
      '#3399CC',
      '#3399FF',
      '#33CC00',
      '#33CC33',
      '#33CC66',
      '#33CC99',
      '#33CCCC',
      '#33CCFF',
      '#6600CC',
      '#6600FF',
      '#6633CC',
      '#6633FF',
      '#66CC00',
      '#66CC33',
      '#9900CC',
      '#9900FF',
      '#9933CC',
      '#9933FF',
      '#99CC00',
      '#99CC33',
      '#CC0000',
      '#CC0033',
      '#CC0066',
      '#CC0099',
      '#CC00CC',
      '#CC00FF',
      '#CC3300',
      '#CC3333',
      '#CC3366',
      '#CC3399',
      '#CC33CC',
      '#CC33FF',
      '#CC6600',
      '#CC6633',
      '#CC9900',
      '#CC9933',
      '#CCCC00',
      '#CCCC33',
      '#FF0000',
      '#FF0033',
      '#FF0066',
      '#FF0099',
      '#FF00CC',
      '#FF00FF',
      '#FF3300',
      '#FF3333',
      '#FF3366',
      '#FF3399',
      '#FF33CC',
      '#FF33FF',
      '#FF6600',
      '#FF6633',
      '#FF9900',
      '#FF9933',
      '#FFCC00',
      '#FFCC33',
    ]);
  function t() {
    return typeof window < 'u' &&
      window.process &&
      (window.process.type === 'renderer' || window.process.__nwjs)
      ? !0
      : typeof navigator < 'u' &&
        navigator.userAgent &&
        navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)
      ? !1
      : (typeof document < 'u' &&
          document.documentElement &&
          document.documentElement.style &&
          document.documentElement.style.WebkitAppearance) || // Is firebug? http://stackoverflow.com/a/398120/376773
        (typeof window < 'u' &&
          window.console &&
          (window.console.firebug ||
            (window.console.exception && window.console.table))) || // Is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        (typeof navigator < 'u' &&
          navigator.userAgent &&
          navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
          parseInt(RegExp.$1, 10) >= 31) || // Double check webkit in userAgent just in case we are in a worker
        (typeof navigator < 'u' &&
          navigator.userAgent &&
          navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
  }
  function o(c) {
    if (
      ((c[0] =
        (this.useColors ? '%c' : '') +
        this.namespace +
        (this.useColors ? ' %c' : ' ') +
        c[0] +
        (this.useColors ? '%c ' : ' ') +
        '+' +
        n.exports.humanize(this.diff)),
      !this.useColors)
    )
      return;
    const h = 'color: ' + this.color;
    c.splice(1, 0, h, 'color: inherit');
    let r = 0,
      a = 0;
    c[0].replace(/%[a-zA-Z%]/g, (d) => {
      d !== '%%' && (r++, d === '%c' && (a = r));
    }),
      c.splice(a, 0, h);
  }
  e.log = console.debug || console.log || (() => {});
  function s(c) {
    try {
      c ? e.storage.setItem('debug', c) : e.storage.removeItem('debug');
    } catch {}
  }
  function i() {
    let c;
    try {
      c = e.storage.getItem('debug');
    } catch {}
    return (
      !c && typeof process < 'u' && 'env' in process && (c = process.env.DEBUG),
      c
    );
  }
  function l() {
    try {
      return localStorage;
    } catch {}
  }
  n.exports = ge(e);
  const { formatters: u } = n.exports;
  u.j = function (c) {
    try {
      return JSON.stringify(c);
    } catch (h) {
      return '[UnexpectedJSONParseError]: ' + h.message;
    }
  };
})(B, B.exports);
var me = B.exports;
const F = /* @__PURE__ */ de(me);
class pe {
  constructor(e, t) {
    g(this, 'options');
    g(this, 'namespace');
    g(this, 'color');
    g(this, 'debugLoggers');
    (this.namespace = e), (this.options = Object.freeze({ ...t }));
    const o = F(e);
    (this.debugLoggers = {
      warn: F(e),
      error: F(e),
      log: F(e),
      info: F(e),
      /*
        TODO: at somepoint in the future we will want to separate the debug
              logger so that we can prevent uploads of debug level logs to UV
      */
      debug: o,
    }),
      (this.color = o.color),
      Object.entries(this.debugLoggers).forEach(([s, i]) => {
        (i.log = console[s].bind(console)),
          (i.color = this.color),
          (i.enabled = !0);
      });
  }
  getChild(e, t) {
    return k(`${this.namespace}:${e}`, {
      ...this.options,
      ...t,
    });
  }
}
let R = [];
const Ce = 5e3,
  ye = (n) => {
    R.push(n);
  },
  q = () => R.splice(0),
  we = () => R.length >= Ce,
  be = {
    log: 'LOG',
    warn: 'WARN',
    error: 'ERROR',
    info: 'INFO',
  },
  Ee = (n) => be[n] ?? 'UNKNOWN',
  Fe = 'undefined',
  ve = /* @__PURE__ */ new Set([
    'string',
    'number',
    'boolean',
    'bigint',
    'symbol',
  ]),
  Ne = (n) => {
    if (n instanceof Error) return n.message.toString();
    if (ve.has(typeof n)) return n.toString();
    if (n === null) return 'null';
    if (Array.isArray(n)) return `Array[${n.length}]`;
    if (n instanceof Object)
      try {
        return JSON.stringify(n);
      } catch {
        return `Object{${Object.keys(n).join(', ')}}`;
      }
    return Fe;
  },
  Te = (n) => n.map(Ne).join(' ');
function _e(n, ...e) {
  const t = {
    t: /* @__PURE__ */ new Date().toISOString(),
    l: n.level,
    ns: n.namespace,
    c: n.color,
    w: window.name,
    log: '',
  };
  return e.length === 0 || (t.log = Te(e)), t;
}
const Se = /* @__PURE__ */ new Set(['log', 'warn', 'error', 'info']);
function Ie(n, e, ...t) {
  if (Se.has(e)) {
    const o = _e(
      {
        level: Ee(e),
        namespace: n.namespace,
        color: n.color,
      },
      ...t,
    );
    return ye(o), o;
  }
}
var S,
  Oe = new Uint8Array(16);
function Me() {
  if (
    !S &&
    ((S =
      (typeof crypto < 'u' &&
        crypto.getRandomValues &&
        crypto.getRandomValues.bind(crypto)) ||
      (typeof msCrypto < 'u' &&
        typeof msCrypto.getRandomValues == 'function' &&
        msCrypto.getRandomValues.bind(msCrypto))),
    !S)
  )
    throw new Error(
      'crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported',
    );
  return S(Oe);
}
const Ae =
  /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ue(n) {
  return typeof n == 'string' && Ae.test(n);
}
var m = [];
for (var $ = 0; $ < 256; ++$) m.push(($ + 256).toString(16).substr(1));
function Le(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0,
    t = (
      m[n[e + 0]] +
      m[n[e + 1]] +
      m[n[e + 2]] +
      m[n[e + 3]] +
      '-' +
      m[n[e + 4]] +
      m[n[e + 5]] +
      '-' +
      m[n[e + 6]] +
      m[n[e + 7]] +
      '-' +
      m[n[e + 8]] +
      m[n[e + 9]] +
      '-' +
      m[n[e + 10]] +
      m[n[e + 11]] +
      m[n[e + 12]] +
      m[n[e + 13]] +
      m[n[e + 14]] +
      m[n[e + 15]]
    ).toLowerCase();
  if (!Ue(t)) throw TypeError('Stringified UUID is invalid');
  return t;
}
function $e(n, e, t) {
  n = n || {};
  var o = n.random || (n.rng || Me)();
  return (o[6] = (o[6] & 15) | 64), (o[8] = (o[8] & 63) | 128), Le(o);
}
const Pe = (n) => {
  if (!navigator.sendBeacon) return !1;
  const { headers: e = {}, data: t, beaconUrl: o, queryParams: s } = n,
    i = `${o}?${s}`,
    l = `{
    "headers": ${JSON.stringify(e)},
    "log": ${t}
  }`,
    u = new Blob([l], { type: 'application/json' });
  return navigator.sendBeacon(i, u);
};
async function Be(n) {
  const { uploadUrl: e, queryParams: t, headers: o, data: s } = n,
    i = re(),
    l = Object.assign({}, o, {
      'Content-Type': 'application/json',
      Authorization: i,
    });
  return {
    url: `${e}?${t}`,
    options: {
      headers: l,
      body: s,
      method: 'POST',
    },
  };
}
async function Re(n) {
  const { url: e, options: t } = await Be(n);
  return fetch(e, t);
}
const xe = '/api/applog/',
  De = '/api/applogbeacon/',
  He = (n) => n === 'error',
  G = async (n, e) => {
    const t = new URLSearchParams(e).toString();
    try {
      await Re({
        uploadUrl: `${n}${xe}`,
        data: JSON.stringify(q()),
        queryParams: t,
      });
    } catch (o) {
      console.error('Failed to upload logs, error:', o);
    }
  },
  je = (n) => {
    const e = new URLSearchParams(n).toString();
    return Pe({
      beaconUrl: De,
      data: JSON.stringify(q()),
      queryParams: e,
    });
  },
  Ge = $e();
async function We(n, e) {
  const t = {
    type: 'web-dp2',
    tab: 'TODO_TAB_ID',
    // TODO (infra-2253): implement tabId
    device: 'TODO_DEVICE_ID',
    // TODO (infra-2254): implement deviceId
    client_instance: Ge,
    // TODO (infra-2252): expose this as a util
  };
  return (
    He(e) &&
      (await G(n.options.apiBaseURL, {
        ...t,
        sub_type: 'unexpected_console_error',
      })),
    we() &&
      (await G(n.options.apiBaseURL, {
        ...t,
        sub_type: 'log_buffer_full',
      })),
    !0
  );
}
const Ve = () => {
  window.addEventListener(
    'pagehide',
    () => {
      je({ sub_type: 'pagehide' });
    },
    !1,
  );
};
Ve();
const qe = [Ie, We];
var ze = { BASE_URL: '/', MODE: 'production', DEV: !1, PROD: !0, SSR: !1 };
const z = [...qe],
  ke = (n) => {
    z.push(n);
  };
function k(n, e = {}) {
  if (n.length === 0) throw new Error('please provide a namespace.');
  const t =
      (e.apiBaseURL && e.apiBaseURL.length > 0
        ? e.apiBaseURL
        : ze.DP_BUILD_UV_HTTP_URL) || '',
    o = new pe(n, {
      ...e,
      apiBaseURL: t,
    }),
    s = {},
    i = (u) => {
      if (s[u]) return s[u];
      const c = le(o, u, z);
      return (s[u] = c), c;
    },
    l = (u) => {
      if (u === 'registerMiddleware') return ke;
      if (u in o) return o[u];
      const c = console[u];
      return typeof c == 'function' ? i(u) : c;
    };
  return new Proxy(Function.prototype, {
    get: (u, c) => l(c),
    apply: (u, c, h) => {
      l('log')(...h);
    },
  });
}
const x = k('noto'),
  O = x.getChild('manager:assignement');
class Ye {
  constructor(e) {
    g(this, 'consumers');
    this.consumers = e;
  }
  /**
   * will it ever be possible to assign this noto to one of our consumers in
   * their current state?
   *
   * @param noto — the noto you're testing for assignment
   * @param trackReasons — if you're attempting to debug the behavior of failed
   *   assignments, pass [] here and you'll find it magically filled out with
   *   the reason(s) that any/all consumers rejected assignment. (it won't be
   *   returned, but ammended in-place).
   *   if there are no consumers registered at all, there will be just one tuple
   *   in there: [null, NO_CONSUMERS];
   * @param allowEarlyReturn — if you're attempting to debug the behavior of
   *   failed assignement, pass false here to get a complete list of reasons for
   *   each consumers. if you leave it as true (the default), you'll only get
   *   one reason from each consumer, which is likely to be one that you already
   *   expected to be there, since the easier conditions are checked first.
   *   there is never a reason to disable this unless tracking rejections.
   */
  hasAnyPossibleConsumer(e, t, o = !0) {
    if (
      (!t &&
        !o &&
        O.warn(
          "there is no reason to prevent early return if you're not debugging rejection reasons!",
        ),
      this.consumers.length === 0)
    )
      return t == null || t.push([null, [y.NO_CONSUMERS]]), !1;
    const s = v.allScopes(e.config);
    let i = !1;
    for (const l of this.consumers) {
      const u = t ? /* @__PURE__ */ new Set() : null;
      if (W(l, e, s, u, o)) {
        if (
          (u != null &&
            u.size &&
            console.error('assignment success had rejection reasons??'),
          o)
        )
          return !0;
        i = !0;
      } else
        u != null && u.size
          ? t == null || t.push([l.id, [...u]])
          : console.error('assignment rejection with no reasons?');
    }
    return i;
  }
  // TODO - possible that we should be converting to NotoConsumerAssignment here
  // but I'll let the manager keep doing that for now, since that's where the
  // state change actually happens (i.e.: noto.assignedTo is set)
  // TODO - probably worth vetting what the best order of operations here is;
  // overall, we could kill N birds with one stone by changing how consumer
  // availability parameters are managed, but I think that would require a lot
  // of extra calls from NotoManager when consumer state changes (e.g. "hey this
  // consumer just got set to active"). that's definitely a reasonable thing to
  // have to do, but not worth the time until we are quite sure it's a
  // meaningful performance bottleneck.
  /**
   * @param noto — the noto you're attempting to assign
   * @param trackReasons — if you're attempting to debug the behavior of failed
   *   assignments, pass [] here and you'll find it magically filled out with
   *   the reason(s) that any/all consumers rejected assignment. (it won't be
   *   returned, but ammended in-place).
   *   if there are no consumers registered at all, there will be just one tuple
   *   in there: [null, NO_CONSUMERS];
   * @param allowEarlyReturn — if you're attempting to debug the behavior of
   *   failed assignement, pass false here to get a complete list of reasons for
   *   each consumers. if you leave it as true (the default), you'll only get
   *   one reason from each consumer, which is likely to be one that you already
   *   expected to be there, since the easier conditions are checked first.
   *   there is never a reason to disable this unless tracking rejections.
   */
  match(e, t, o = !0) {
    const s = new v(e.config);
    !t &&
      !o &&
      (O.warn(
        "there is no reason to prevent early return if you're not debugging rejection reasons!",
      ),
      (o = !0));
    const i = v.allScopes(e.config);
    for (const l of this.consumers) W(l, e, i) && s.addConsumer(l);
    return (
      !s.hadAnyMatch && t && this.hasAnyPossibleConsumer(e, t, o), s.bestMatch
    );
  }
  // this might be a useful check, but i just rocked it out in like 20
  // minutes. we can look into it more if people need more flexibility.
  //private narrowDownMatches (
  //matched: NotoConsumerRegistration[]
  //): NotoConsumerRegistration[] {
  // TODO - here's some experimental thought: if there are multiple
  // matching consumers in the same scope, some using explcit types and
  // some with null (fallback) types, ignore the fallbacks in that scope and
  // let the explicit consumers take all the glory.
  //
  // in reality, there are a lot of ways we could provide better filtering,
  // but I don't want to go overboard right away, so we keep it pretty simple
  // (to specify on creators/consumers, at least) while also avoiding the need
  // for a lot of chatter between different parts of the system (threads)
  //let hasExplicitTypeMatch = 0;
  //let allMatchesExplicit = true;
  //for (const { types, scope } of matched) {
  // this consumer accepts explicit types, mark the whole scope as explicit:
  //if (types !== null) hasExplicitTypeMatch |= scope;
  // there was at least one fallback
  //else allMatchesExplicit = false;
  //}
  // it was all fallbacks, no explict, so the matches stay the same
  //if (hasExplicitTypeMatch === 0) return matched;
  // on the other hand, if there were NO fallbacks, there's nothing to filter
  //if (allMatchesExplicit) return matched;
  // if we got both explicit and fallback matches, maybe pare down the list:
  //const narrowerMatches: NotoConsumerRegistration[] = [];
  //for (const m of matched) {
  // if this match was a fallback, but its scope had another match that was
  // explicitly typed, we will skip the fallback(s)
  //if (m.types === null && (hasExplicitTypeMatch & m.scope)) continue;
  // otherwise, it's explicitly typed OR none were explicit, so keep it in.
  //else narrowerMatches.push(m);
  //}
  // TODO - one last thing: I think including a "requireSingle" flag for Noto
  // configs may be enough to make this (still relatively simple) scheme good
  // enough to roll with for a while: when this flag is set, if we still have
  // multiple matched consumers, we can just pick one based on (for example)
  // whatever one was most recently set to active. Maybe later, though.
  //return narrowerMatches;
  //}
}
class v {
  constructor(e) {
    g(this, 'matches');
    g(this, '_matchCount');
    g(this, 'matchesUsed');
    g(this, 'allScopes');
    (this._matchCount = 0),
      (this.matchesUsed = !1),
      (this.matches = e.scopePriority.map((t) => [t, null])),
      (this.allScopes = v.allScopes(e));
  }
  // figures out ALL possible allowed scopes in scopePriority
  static allScopes(e) {
    let t = 0;
    for (const o of e.scopePriority) t |= o;
    return t;
  }
  addConsumer({ id: e, scope: t }) {
    if (this.matchesUsed)
      throw new Error('cant add any more matches after starting to use them!');
    for (const o of this.matches)
      if (o[0] & t) {
        this._matchCount++, o[1] ?? (o[1] = []), o[1].push(e);
        return;
      }
    throw new Error(
      `consumer id=${e} w/ scope ${t} is being added as a match but does
      not share a scope with any of the given scopePriorities!`,
    );
  }
  get matchCount() {
    return this._matchCount;
  }
  get hadAnyMatch() {
    return this._matchCount > 0;
  }
  /**
   * iterate over all priority levels that had a match + the ids that matched
   */
  *[Symbol.iterator]() {
    if (((this.matchesUsed = !0), !!this.hadAnyMatch))
      for (const [e, t] of this.matches) t && (yield [e, t]);
  }
  /**
   * return the first list of ids that actually got some action, or null if we
   * had no matches!
   */
  get bestMatch() {
    for (const [, e] of this.matches) if (e) return e;
    return null;
  }
}
function W(n, e, t = null, o, s = !0) {
  if (!n.alive)
    return (
      O.error('assignment matcher got consimer with alive=false', n),
      o == null || o.add(y.NOT_ALIVE),
      !1
    );
  !s &&
    !o &&
    (O.warn(
      'ignoring earlyReturn=false since the rejection reasons are not being recorded!',
    ),
    (s = !0));
  let i = !0;
  const l = o
    ? // if tracking reasons, keep going if earlyReturn has been manually 0'd
      (c) => ((i = !1), o.add(c), s)
    : // if theres no reasons Set, don't even check, just insta-return.
      () => !0;
  if (
    (t !== null && !(t & n.scope) && l(y.WRONG_SCOPES)) ||
    (e.config.requiresActive && !n.active && l(y.REQUIRES_ACTIVE)) ||
    (n.types && !n.types.has(e.type) && l(y.WRONG_TYPES)) ||
    (n.types === null &&
      e.config.requiresExplicitType &&
      l(y.REQUIRES_EXPLICIT_TYPE)) ||
    (e.config.sameWindow && e.originWindow !== n.windowId && l(y.WRONG_WINDOW))
  )
    return !1;
  const u = n.metaFilter;
  if (u) {
    const c = e.meta;
    for (const h in u)
      if (h in c) {
        if (u[h] !== c[h] && l(y.META_FILTER_VALUE_MISMATCH)) return !1;
      } else if (l(y.META_FILTER_MISSING_FIELD)) return !1;
  }
  return i;
}
const f = x.getChild('manager');
class Je {
  constructor() {
    // all registered consumers
    g(this, 'consumers');
    // map consumers by id
    g(this, 'consumerMap');
    // all currently-active notos
    g(this, 'notos');
    // map notos by id
    g(this, 'notoMap');
    // all the ids for notos which had no consumers available at creation time,
    // and still don't.
    g(this, 'unassignedNotoIds');
    // mechanism to debounce rapid calls to "pollUnassignedNotos"
    g(this, 'pollUnassignedNotosHandle');
    // stores the handle from calling setTimeout to auto-remove a noto with a ttl
    // for each noto that is currently configured to auto expire.
    g(this, 'notoTimeouts');
    // TODO - a temporary pass-through pending creation of TG service! this is how
    // we relay events to creators. note that for merged notos, only the most
    // recent creator is able to get news of events. (hence why I'm not trying
    // to store it in a more clever way, that's thread goblin's job)
    g(this, 'notoCreatorEventHandlers');
    g(this, 'assignmentMatcher');
    // bind to this because we'll use it as a setTimeout callback
    g(this, 'pollUnassignedNotos', this._pollUnassignedNotos.bind(this));
    f.debug('created'),
      (this.consumerMap = {}),
      (this.consumers = []),
      (this.notoMap = {}),
      (this.notos = []),
      (this.notoCreatorEventHandlers = {}),
      (this.unassignedNotoIds = /* @__PURE__ */ new Set()),
      (this.pollUnassignedNotosHandle = null),
      (this.notoTimeouts = {}),
      (this.assignmentMatcher = new Ye(this.consumers));
  }
  /**
   * rather than being called directly from the client, make this a TG thing
   */
  registerConsumer(e) {
    f.log('registerConsumer', e);
    const t = H(),
      o = {
        id: t,
        scope: e.scope,
        windowId: e.windowId,
        assignedNotos: /* @__PURE__ */ new Set(),
        // true until disconnected.
        alive: !0,
        // for clarity, the eventArgs should be (noto, [some extra stuff maybe])
        client: (...s) => {
          e.client(t, ...s);
        },
        types: e.types ?? null,
        metaFilter: e.metaFilter ?? null,
        // cant start as true, force the consumer to call setActive when it feels
        // good about its own registration.
        active: !1,
      };
    return this.consumers.push(o), (this.consumerMap[t] = o), t;
  }
  getNotoById(e) {
    const t = this.notoMap[e];
    if (!t) throw new Error(`no Noto with id=${e}`);
    if (!t.alive) throw new Error(`Noto with id=${e} is dead`);
    return t;
  }
  getConsumerById(e) {
    const t = this.consumerMap[e];
    if (!t) throw new Error(`no consumer id=${e}`);
    if (!t.alive) throw new Error(`consumer id=${e} is dead!`);
    return t;
  }
  // all consumers which have had this noto assigned to them, if any
  getAssignedConsumers(e) {
    var s;
    const o =
      (s = (typeof e == 'string' ? this.getNotoById(e) : e).assignedTo) == null
        ? void 0
        : s.map(({ id: i }) => this.getConsumerById(i));
    return o && o.length > 0 ? o : null;
  }
  // all notos which are assigned to this consumer
  getAssignedNotos(e) {
    const t = typeof e == 'string' ? this.getConsumerById(e) : e;
    return Array.from(t.assignedNotos, (o) => this.getNotoById(o));
  }
  get consumerCount() {
    return this.consumers.length;
  }
  get notoCount() {
    return this.notos.length;
  }
  consumerIndex(e) {
    const t = this.consumerCount;
    for (let o = 0; o < t; o++) if (this.consumers[o].id === e) return o;
    return null;
  }
  notoIndex(e) {
    const t = this.notoCount;
    for (let o = 0; o < t; o++) if (this.notos[o].id === e) return o;
    return null;
  }
  disconnectConsumer(e) {
    var t, o, s;
    f.log('disconnectConsumer', e);
    try {
      const i = this.getConsumerById(e);
      if (i.id !== e)
        throw new Error(`consumer.id=${i.id} did not match arg id=${e}`);
      i.id in this.consumerMap
        ? delete this.consumerMap[i.id]
        : f.error(`consumer id=${e} was not in consumer map?`);
      const l = this.consumerIndex(e);
      if (
        (l !== null
          ? this.consumers.splice(l, 1)
          : f.error(`consumer id=${e} was not in consumer array?`),
        Object.assign(i, { alive: !1 }),
        i.assignedNotos.size > 0)
      ) {
        const u = [];
        for (const c of i.assignedNotos) {
          const h = this.getNotoById(c),
            r =
              ((t = h.assignedTo) == null
                ? void 0
                : t.findIndex((a) => a.id === e)) ?? -1;
          r !== -1
            ? (o = h.assignedTo) == null || o.splice(r, 1)
            : f.warn(
                `found ghost assignment: consumer id=${e} was already
              removed from noto id=${c} assignedTo list?`,
              ),
            ((s = h.assignedTo) == null ? void 0 : s.length) === 0 && u.push(h);
        }
        u.length > 0 &&
          (f.warn(`disconnecting consumer id=${e} has left orphans!`),
          this.rescueOrphanedNotos(u));
      }
    } catch (i) {
      f.warn(`uncaight error disconnecting consumer id=${e}`, {
        ex: i,
      });
    }
  }
  // these notos were assigned at some point but they were left without a
  // consumer for some reason. Right now, I don't even know what the best
  // thing to do would be, so just log it, I guess. We *could* close them or
  // add them to the unassigned pool or make it an error, or let their creator
  // know. Not sure!
  rescueOrphanedNotos(e) {
    var t;
    for (const o of e)
      (((t = o.assignedTo) == null ? void 0 : t.length) ?? 0) > 0
        ? f.error(' ! why is a non-orphan being reported as such???')
        : (f.warn(' - orphan', o),
          Object.assign(o, { assignedTo: null }),
          this.unassignedNotoIds.add(o.id));
    this.scheduleUnassignedPoll();
  }
  setConsumerTypeFilter(e, t) {
    f.log('setConsumerTypeFilter', e, t);
    const o = this.getConsumerById(e);
    (o.types = t), this.scheduleUnassignedPoll();
  }
  setConsumerMetaFilter(e, t) {
    const o = this.getConsumerById(e);
    (o.metaFilter = t), this.scheduleUnassignedPoll();
  }
  setConsumerActive(e, t) {
    f.log('setConsumerActive', e, t);
    const o = this.getConsumerById(e);
    t !== o.active && ((o.active = t), t && this.scheduleUnassignedPoll());
  }
  // never call directly, only through createNoto in ./create.ts
  createNoto(e, t) {
    f.log('createNoto', e);
    const o = this.overwriteExistingNoto(e, t);
    if (o) return o;
    const s = {
      id: H(),
      alive: !0,
      type: e.type,
      meta: e.meta ?? {},
      created: Date.now(),
      originWindow: null,
      // TODO - tg-based message could be window/tab-aware
      assignedTo: null,
      replaced: !1,
      config: e.config,
      content: e.content,
    };
    return (
      this.notos.push(s),
      (this.notoMap[s.id] = s),
      (this.notoCreatorEventHandlers[s.id] = t),
      f.debug('noto create:', s, this),
      this.assignNoto(s, !0),
      s
    );
  }
  overwriteExistingNoto(e, t) {
    const o = this.findMergableNoto(e);
    return o
      ? (Object.assign(o, {
          replaced: !0,
          created: Date.now(),
          // TODO - handle origin window. probably doesn't matter much if you're
          // merging them without caring where they came from, but worth mentioning
          originWindow: null,
        }),
        this.updateInternalNoto(o, e, !0),
        (this.notoCreatorEventHandlers[o.id] = t),
        this.scheduleTTL(o),
        f.debug('noto overwrite:', o),
        o)
      : null;
  }
  scheduleTTL(e) {
    if ((this.clearTTLHandle(e.id), !e.config.ttl || !e.assignedTo)) return;
    const t = e.config.ttl * 1e3,
      s = setTimeout(() => {
        const i = this.notoTimeouts[e.id];
        s === i &&
          (delete this.notoTimeouts[e.id], this.removeNoto(e.id, I.TIMEOUT));
      }, t);
    this.notoTimeouts[e.id] = s;
  }
  clearTTLHandle(e) {
    clearTimeout(this.notoTimeouts[e]), delete this.notoTimeouts[e];
  }
  findMergableNoto(e) {
    let t = e.config.mergeRelated;
    if (!t) return null;
    t === !0 && (t = []);
    for (const o of Object.values(this.notoMap))
      if (this.areNotosMergable(e, o, t)) return o;
    return null;
  }
  /**
   * true when the Noto specified by args should replace the state of `noto`
   * instead of just creating a whole new one. "fields" is the combined set of
   * metafields which need to be equal between both.
   */
  areNotosMergable(e, t, o) {
    if (!e.config.mergeRelated)
      throw new Error('this noto is never mergeable!');
    return t.alive
      ? t.type === e.type &&
          o.every((s) => {
            const i = e.meta[s],
              l = t.meta[s];
            return i === l;
          })
      : (f.warn(`found dead noto id=${t.id}`), !1);
  }
  /**
   * a consumer/or creator sends a message which eventually calls this function
   * causing the state of the noto to change, and propagating an onUpdated event
   * to all the relevant consumers/creators.
   *
   * pretty much just being called raw from the Creator/ConsumerHandles at this
   * point, but when thread-goblin comes to town, we'll want to vet that it was
   * sent via a channel that has a valid interest in the id given.
   */
  updateNoto(e, t) {
    t.config && f.warn(`public update on noto id=${e} has config`, t),
      this.updateInternalNoto(e, t, !1);
  }
  updateInternalNoto(e, t, o) {
    if (!(t.config || t.meta || t.content)) return;
    const s = typeof e == 'object' ? e : this.getNotoById(e),
      i = s.id;
    t.config && Object.assign(s.config, t.config),
      t.meta && Object.assign(s.meta, t.meta),
      t.content && Object.assign(s.content, t.content);
    try {
      const l = o ? 'onReplaced' : 'onUpdated';
      try {
        const c = this.notoCreatorEventHandlers[i];
        c(l, s);
      } catch (c) {
        f.error(`creator of noto id=${i} threw during ${l}`, { ex: c });
      }
      const u = this.getAssignedConsumers(i);
      if (u)
        for (const c of u)
          try {
            c.client('onUpdated', s);
          } catch (h) {
            f.error(
              `consumer id=${c.id} of noto id=${i} threw during onUpdated`,
              { ex: h },
            );
          }
    } catch (l) {
      f.error(`uncaught exception updating noto id=${i}`, l, t);
    }
  }
  /**
   * find one or more consumers that can accept this noto and assign them to it.
   * @param noto — the noto that needs assignment
   * @param late — whether this is an initial attempt at assignment
   */
  assignNoto(e, t) {
    if (e.assignedTo) {
      f.error('this noto is already assigned?', { noto: e });
      return;
    }
    const o = this.assignmentMatcher.match(e);
    if (!o) {
      t && this.unassignedNotoIds.add(e.id);
      return;
    }
    const s = [],
      i = [];
    for (const u of o) {
      const c = this.getConsumerById(u);
      c.assignedNotos.add(e.id),
        s.push(c),
        i.push({
          id: c.id,
          windowId: c.windowId,
          scope: c.scope,
        });
    }
    Object.assign(e, { assignedTo: i }), this.scheduleTTL(e);
    const l = t ? null : this.notoCreatorEventHandlers[e.id];
    this.dispatchAssignmentEvents(e, s, l);
  }
  dispatchAssignmentEvents(e, t, o) {
    for (const s of t)
      try {
        s.client('onAssigned', e);
      } catch (i) {
        f.error(
          `consumer id=${s.id} of noto id=${e.id} threw during onAssigned`,
          { noto: e, ex: i },
        );
      }
    if (o)
      try {
        o('onAssigned', e);
      } catch (s) {
        f.error(`creator of noto id=${e.id} threw during onAssigned`, {
          noto: e,
          ex: s,
        });
      }
  }
  removeFromUnassignedNotos(e) {
    this.unassignedNotoIds.delete(e);
  }
  _pollUnassignedNotos() {
    for (const e of this.unassignedNotoIds)
      try {
        const t = this.getNotoById(e);
        this.assignNoto(t, !1);
      } catch (t) {
        f.error(`error while trying to assign noto id=${e}`, t);
      }
  }
  scheduleUnassignedPoll() {
    if (
      (this.pollUnassignedNotosHandle &&
        (clearTimeout(this.pollUnassignedNotosHandle),
        (this.pollUnassignedNotosHandle = null)),
      this.unassignedNotoIds.size > 0)
    ) {
      const e = setTimeout(this.pollUnassignedNotos, Qe);
      this.pollUnassignedNotosHandle = e;
    }
  }
  // called when an action is taken, dispatch onAction to the creator/consumers
  actionTaken(e, t, o) {
    const s = this.notoCreatorEventHandlers[e],
      i = this.getNotoById(e);
    if (!i.assignedTo)
      throw new Error(`noto id=${e} took action ${t} before assigned?`);
    s('onAction', i, t, o);
  }
  // remove a noto and dispatch onClosed to its creator & all assigned consumers
  // TODO - we don't currently track multiple creators if the noto of one was
  // replaced by that of another. Doubt this will cause problems, but if it does
  // then this is one place to take corrective action.
  removeNoto(e, t) {
    this.removeFromUnassignedNotos(e), this.clearTTLHandle(e);
    try {
      const o = this.notoCreatorEventHandlers[e];
      delete this.notoCreatorEventHandlers[e];
      const s = this.getNotoById(e);
      Object.assign(s, { alive: !1 }),
        s.id in this.notoMap
          ? delete this.notoMap[s.id]
          : f.error(`noto id=${s.id} was not in noto map?`);
      const i = this.notoIndex(e);
      i !== null
        ? this.notos.splice(i, 1)
        : f.error(`noto id=${s.id} was not in noto array?`);
      try {
        o('onClosed', s, t);
      } catch (u) {
        f.error(`creator of noto id=${s.id} threw during onClosed`, {
          noto: s,
          ex: u,
        });
      }
      const l = this.getAssignedConsumers(s);
      if (l)
        for (const u of l)
          try {
            u.assignedNotos.delete(s.id), u.client('onClosed', s, t);
          } catch (c) {
            f.error(`consumer id=${u.id} threw during onClosed`, {
              noto: s,
              ex: c,
            });
          }
    } catch (o) {
      f.error(`uncaught exception removing noto id=${e}`, o);
    }
  }
  isConsumerAssignedToNoto(e, t) {
    try {
      return this.getConsumerById(e).assignedNotos.has(t);
    } catch (o) {
      return (
        f.warn('got exception when checking noto assignment!', {
          ex: o,
          consumerId: e,
          notoId: t,
        }),
        !1
      );
    }
  }
}
let V = null;
async function Y() {
  return V ?? (V = new Je()), V;
}
const Qe = 50,
  P = x.getChild('consumer'),
  M = {},
  J = {};
function Xe(n, e, ...t) {
  if (!M[n]) {
    P.error(
      `consumer id=${n} got message after removal from consumer service?`,
    );
    return;
  }
  const s = J[n][e];
  if (!s) {
    P.error(`consumer id=${n} has no handler for event "${e}"; args:`, t);
    return;
  }
  P.debug(`forwarding ${e} event to consumer id=${n}`, t), s(...t);
}
function Ze(n) {
  M[n] &&
    (delete M[n],
    Y().then((e) => {
      e.disconnectConsumer(n);
    }));
}
async function tt(n, e) {
  const t = e ?? (await Y()),
    o = t.registerConsumer({
      windowId: oe(),
      scope: n.scope,
      client: Xe,
      types: n.types ? new Set(n.types) : null,
      metaFilter: n.metaFilter ? { ...n.metaFilter } : null,
    }),
    s = {
      id: o,
      scope: n.scope,
      disconnect: Ze.bind(null, o),
      // jury is still out on whether this should be allowed
      setTypeFilter: (i) => {
        t.setConsumerTypeFilter(o, i);
      },
      setMetaFilter: (i) => {
        t.setConsumerMetaFilter(o, i);
      },
      setActive: (i) => {
        t.setConsumerActive(o, i);
      },
      close: (i, l = !0) => {
        const u = l ? I.USER : I.CONSUMER;
        t.removeNoto(i, u);
      },
      action: (i, l, u) => {
        t.actionTaken(i, l, u);
      },
    };
  return (
    (M[o] = s),
    (J[o] = {
      onAssigned: n.onAssigned,
      onClosed: n.onClosed,
      onUpdated: n.onUpdated,
    }),
    s
  );
}
export { te as N, I as a, y as b, tt as c, Je as d, Y as g, x as l };
